<div class="country_mobile_dropdown">
  <div class="flex gap-3 items-start xs-6:flex-col xs-6:gap-2">
    <div fxFlex="50" style="background: white" class="xs-6:w-full">
      <mat-select
        class="mat-select-country-code form-select-mat text-1 border-gris !rounded-[6px]"
        (selectionChange)="getcode($event.value)"
        [formControl]="country_code"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="codeFilterCtrl"
            placeholderLabel="Search"
            noEntriesFoundLabel="'No match found'"
          ></ngx-mat-select-search>
        </mat-option>
        @for (phonecode of newcountryCodedata; track phonecode) {
          <mat-option class="text-1" value="{{ phonecode.id }}">
            {{ phonecode.name }} (+{{ phonecode.phone_code }})
          </mat-option>
        }
      </mat-select>
    </div>

    <div fxFlex class="xs-6:w-full">
      <input
        placeholder="Enter phone number"
        type="text"
        [formControl]="mobile_number"
        (input)="mobileNumberValidation()"
        (keyup)="mobileNumberValidation()"
        appNumbersOnly
        class="form-control br-color-2 ph-1 h-[39px] mt-[5px]"
        [ngClass]="{ 'border-danger': inValidMobileNumber }"
      />
    </div>
  </div>
  @if (inValidMobileNumber) {
    <span class="error-message block ms-1 mt-1 text-danger fs-8">
      {{ 'ON_BOARDING_ERR.ERRORMOBILEVALIDATION' | translate }}
    </span>
  }
</div>
